import { ScrollArea } from "@/components/ui/scroll-area";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-8">
        <ScrollArea className="h-full">
          <div className="max-w-3xl mx-auto space-y-8">
            <h1 className="text-3xl font-bold">Privacy Policy</h1>
            <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Introduction</h2>
              <p>
                At Habitualy (a Meetzi app), we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our habit tracking application.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Information We Collect</h2>
              <div className="space-y-2">
                <h3 className="text-xl font-medium">1. Personal Information</h3>
                <p>We collect:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Email address (for authentication)</li>
                  <li>Username (if provided)</li>
                  <li>Authentication data (securely managed through our authentication provider)</li>
                </ul>

                <h3 className="text-xl font-medium">2. Usage Data</h3>
                <p>We collect:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Habit tracking data you input</li>
                  <li>Application interaction patterns</li>
                  <li>Device information (type, operating system)</li>
                </ul>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide and maintain our service</li>
                <li>To notify you about changes to our service</li>
                <li>To provide customer support</li>
                <li>To detect, prevent, and address technical issues</li>
                <li>To improve our application based on your feedback and usage</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Data Storage and Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure.
              </p>
              <p>
                Your data is stored securely in cloud databases with industry-standard encryption. We regularly backup data and maintain security protocols to prevent unauthorized access.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Data Retention</h2>
              <p>
                We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy. You can request deletion of your account and associated data at any time.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Export your data</li>
                <li>Withdraw consent for data processing</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold">Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at support@meetzi.app
              </p>
            </section>
          </div>
        </ScrollArea>
      </main>
      <Footer />
    </div>
  );
} 